import { render, staticRenderFns } from "./UserLicensesCard.vue?vue&type=template&id=7c8edf18"
import script from "./UserLicensesCard.vue?vue&type=script&lang=js"
export * from "./UserLicensesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports